import { correspondenceEntityTypesMap } from "../types"
import { z } from "zod"

export type CorrespondenceThreadSearchEntityType = z.infer<
  typeof CorrespondenceThreadSearchSchema.shape.entityType
>

export const CorrespondenceThreadSearchSchema = z.object({
  entityType: z.enum(correspondenceEntityTypesMap),
  entityId: z.number().optional(),
})
